import { GridColProps, FlexBasisType } from './types';

export const getFlexBasis = (col: GridColProps) => {
    let flexBasis: FlexBasisType = 'flexBasis10';

    if (col.flexBasis) {
        flexBasis = col.flexBasis;
    }

    return flexBasis;
};
